<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
        <h6>Registro de usuarios.</h6>
    </div>
</header>
@if(loading){
<div class="loading-overlay">
    <div class="loading-indicator">Cargando datos...</div>
</div>
}

<oaj-alert-itx></oaj-alert-itx>

<div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
    <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
        <div class="card-body">
            <label class="form-label mb-1" for="tipoOrganismoSelect">Selección Tipo de Órgano</label>
            <div class="d-flex align-items-center gap-2">

                <ng-select placeholder="Seleccione una opción" id="tipoOrganismoSelect" name="tipoOrganismoSelect"
                    class="select-v2" [(ngModel)]="selectedOrganismoId" (change)="onChangeOrgano($event)">
                    @for (organo of TiposOrganos; track $index) {
                    <ng-option [value]="organo.catTipoOrganismoId">
                        {{ organo.catTipoOrganismoId }} - {{ organo.nombre }}
                    </ng-option>
                    }
                </ng-select>

            </div>
            <br />
            <div class="row">
                <label class="form-label mb-1" for="">Selecciona los organos a los que se generara usuario</label>
                <label class="form-label mb-1" for="Iniciales">Ingresa Iniciales para confirguarar el usuario:</label>
                <div class="col-2">
                    <div class="form-group">
                        <input type="text" id="Iniciales" [(ngModel)]="Iniciales" name="Iniciales"
                            placeholder="Iniciales">
                    </div>
                </div>
            </div>
            <br />
            <button class="btn btn-envio btn-sm" (click)="registroUsuarios()">
                <i class="fas fa-user icon"></i>
                Registrar Usuarios
            </button>

        </div>
    </div>
</div>


<div [hidden]="mostrarTablaOrganos" class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
    <div class="card shadow-sm" style="max-width: 90%; width: 100%;">
        <div class="card-body">
            @if(mostrarTablaOrganos){
            <div class="autoridades-filter-bar">
                <div class="filter-group">
                    <label for="filtro-autoridades">Filtrar organos:</label>
                    <div class="input-wrapper">
                        <i class="fas fa-search icon"></i>
                        <input type="text" id="filtro-autoridades" placeholder="" [(ngModel)]="filterOrgano">

                        <!-- <input type="text"  id="filtro-autoridades" [(ngModel)]="searchOrgano" (keyup)="filtrarOrgano()"> -->

                    </div>
                </div>
            </div>
            }
            <div>
                @if(mostrarTablaUsuarios)
                {
                <button class="btn btn-envio btn-sm" (click)="exportToExcel()">Exportar a
                    Excel <i class="fas fa-file-excel"></i></button>
                }
            </div>


            <br />

            <div class="table-container">
                @if(mostrarTablaOrganos){
                <table>
                    <thead>
                        <tr>
                            <th><input type="checkbox" (change)="toggleAll($event)"></th>
                            <th>ID Organo</th>
                            <th>Nombre de Organo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- @for (organo of (listOrganos | async) ; track organo.organismId) { -->
                        @for (organo of listOrganos; track organo.organismId) {
                        <tr>
                            <td><input type="checkbox" [(ngModel)]="organo.selected"
                                    (change)="onCheckboxChange(organo)">
                            </td>
                            <td [innerHTML]="organo.organismId.toString()| highlight:searchOrgano"></td>
                            <td [innerHTML]="organo.organismName | highlight:searchOrgano"></td>
                            <!-- <td>
                                    {{ organo.organismId }}
                                </td>
                                <td>
                                    {{organo.organismName}}
                                </td> -->
                        </tr>
                        }

                    </tbody>
                </table>
                }


                <!-- Paginación -->
                <!-- <div class="pagination">
                        <span>Núm. página {{currentPage}} total registros por página {{filtroListOrganos.length}}</span>
                        <button class="pagination-btn" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"><i
                                class="fas fa-chevron-left"></i></button>
                        <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                            [disabled]="currentPage * pageSize >= filtroListOrganos.length"><i class="fas fa-chevron-right"></i></button>
                    </div> -->

                <!-- Tabla de usuario -->
                @if(mostrarTablaUsuarios){
                <table>
                    <thead>
                        <tr>
                            <th>ID Organo</th>
                            <th>Nombre de Organo</th>
                            <th>Usuario</th>
                            <th>Password</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (user of RegistroUsuario ; track user.catOrganismoId) {
                        <tr>
                            <td>
                                {{ user.catOrganismoId }}
                            </td>
                            <td>
                                {{user.nombreOrgano}}
                            </td>
                            <td>
                                {{user.usuario}}
                            </td>
                            <td>
                                {{user.password}}
                            </td>
                        </tr>
                        }
                        <!-- <tr *ngFor="let usuario of RegistroUsuario">
                                <td>{{ usuario.catOrganismoId }}</td>
                                <td>{{ usuario.nombreOrgano }}</td>
                                <td>{{ usuario.usuario }}</td>
                                <td>{{ usuario.password }}</td>
                            </tr> -->

                    </tbody>
                </table>
                }


            </div>



        </div>
    </div>
</div>